var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n    You "),_c('i',{staticClass:"tim-icons icon-heart text-primary"}),_vm._v(" TRAX LRS?\n    "),_c('a',{attrs:{"href":"http://traxlrs.com","target":"_blank","rel":"noopener"}},[_vm._v("Support us!")]),_vm._v(" "),_c('span',{staticClass:"version ml-4"},[_vm._v(_vm._s(_vm.version))])])
}
var staticRenderFns = []

export { render, staticRenderFns }